<template>
	<div id="custom-button" v-bind:class="{ inverse: inverse }">
		<font-awesome-icon
			v-if="previous_icon"
			:icon="previous_icon"
			class="custom-buttom-icon"
		/>
		<span> {{ text }}</span>
	</div>
</template>

<script>
export default {
	name: "CustomButton",
	props: ["inverse", "previous_icon"],
	data() {
		return {
			text: this.$attrs.text || null
		};
	}
};
</script>

<style>
#custom-button {
	height: 32px;
	border-radius: 11px;
	background-color: var(--active);
	line-height: 32px;
	padding: 3px 16px 3px 16px;
	text-align: center;
	cursor: pointer;
	color: #ffffff;
}

#custom-button.inverse {
	background-color: transparent;
	border: 2px solid var(--active);
	color: var(--active);
}

#custom-button > span {
	font-size: 15px;
	font-weight: 500;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
}
.custom-buttom-icon {
	font-size: 17px;
	margin-right: 10px;
}
</style>
